import createIcon from '../../createIcon';

/**
 * @component @name UnfoldLess
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy40MTAxNiAxOC41OUw4LjgzMDE2IDIwTDEyLjAwMDIgMTYuODNMMTUuMTcwMiAyMEwxNi41ODAyIDE4LjU5TDEyLjAwMDIgMTRMNy40MTAxNiAxOC41OVpNMTYuNTkwMiA1LjQxTDE1LjE3MDIgNEwxMi4wMDAyIDcuMTdMOC44MzAxNiA0TDcuNDEwMTYgNS40MUwxMi4wMDAyIDEwTDE2LjU5MDIgNS40MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UnfoldLess = createIcon('UnfoldLess', [
  [
    'path',
    {
      d: 'M7.41016 18.59L8.83016 20L12.0002 16.83L15.1702 20L16.5802 18.59L12.0002 14L7.41016 18.59ZM16.5902 5.41L15.1702 4L12.0002 7.17L8.83016 4L7.41016 5.41L12.0002 10L16.5902 5.41Z',
      key: '7aimqt',
    },
  ],
]);

export default UnfoldLess;
